export function calculateETA(minDays = 3, maxDays = 7, pickupDays = 2) {
    // Number of days for arrival is based on gift cert only (faster) or mixed order.
    const today = new Date(); // kept for parity, even if unused
  
    // Helper to get current time in PST to avoid timezone edge cases
    const getNowInPST = () => {
        const now = new Date();
      
        const formatter = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/Los_Angeles",
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
        });
      
        const parts = formatter.formatToParts(now).reduce((acc, part) => {
          if (part.type !== "literal") {
            acc[part.type] = part.value;
          }
          return acc;
        }, {});
      
        const year = Number(parts.year);
        const month = Number(parts.month) - 1; // JS months are 0-based
        const day = Number(parts.day);
        const hour = Number(parts.hour || 0);
        const minute = Number(parts.minute || 0);
        const second = Number(parts.second || 0);
      
        return new Date(year, month, day, hour, minute, second);
      };
  
    const nowPST = getNowInPST();
  
    // Adds a number of business days (skipping weekends) to a date
    const addDays = (date, days) => {
      const result = new Date(date);
      let added = 0;
  
      while (added < days) {
        result.setDate(result.getDate() + 1); // always move forward first
  
        const day = result.getDay();
        if (day !== 0 && day !== 6) {
          added++;
        }
      }
  
      return result;
    };
  
    // Determine if a date is a business day
    const isBusinessDay = (date) => {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    };
  
    // Get hour of day in PST
    const getPSTHour = (date) => {
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Los_Angeles",
        hour: "numeric",
        hour12: false,
      });
  
      return parseInt(formatter.format(date), 10);
    };
  
    // Check if current PST time is before 10AM cutoff
    const isBeforeCutoff = (date) => getPSTHour(date) < 10;
  
    // Determine start date for pickup prep window
    const pickupStartDate =
      isBusinessDay(nowPST) && isBeforeCutoff(nowPST)
        ? nowPST
        : addDays(nowPST, 1);
  
    // Shipping always starts next business day
    const shippingStartDate = addDays(nowPST, 1);
  
    // Delivery windows
    const etaMin = addDays(shippingStartDate, minDays);
    const etaMax = addDays(shippingStartDate, maxDays);
    const etaPickup = addDays(pickupStartDate, pickupDays);
  
    // Date formatting for user display
    const options = { month: "2-digit", day: "2-digit", year: "2-digit" };
    const etaMinStr = new Intl.DateTimeFormat("en-US", options).format(etaMin);
    const etaMaxStr = new Intl.DateTimeFormat("en-US", options).format(etaMax);
    const etaPickupStr = new Intl.DateTimeFormat("en-US", options).format(
      etaPickup
    );
  
    return {
      etaMinStr,
      etaMaxStr,
      etaPickupStr,
    };
  }